import React from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import validate from '@vlabs/shared/validators';
import {
  Divider, Control, Step,
} from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import st from './StepFilters.module.sass';

export function StepFacesFilters(): React.JSX.Element {
  const { t } = useTranslation();
  const { control, register, formState: { errors } } = useFormContext();
  const listOptions = useSelector(selectListOptions);

  return (
    <Step>
      <h6>{t('features:exportTask.form.titles.filters')}</h6>
      <Divider small />

      <div className={st.Filters}>
        <div className={st.Column}>
          <Control.Select
            control={control}
            errors={errors}
            id="content.filters.list_id"
            isClearable
            isCreatable
            label={t('list') as unknown as string}
            name="content.filters.list_id"
            options={listOptions}
            rules={{ validate: validate.uuidOptions }}
          />
          <Divider small />

          <Control.Input
            id="content.filters.user_data"
            label={t('user_data') as unknown as string}
            {...register('content.filters.user_data', { maxLength: validate.maxLength(128) })}
            errors={errors}
            placeholder={t('enter') as unknown as string}
          />
          <Divider small />

          <Control.DateInput
            control={control}
            enableTime
            id="content.filters.create_time__gte"
            label={t('create_date_from') as unknown as string}
            name="content.filters.create_time__gte"
            options={START_OF_DAY}
            placeholder={t('choose_dates') as unknown as string}
          />
          <Divider small />

          <Control.Input
            id="content.filters.face_id__gte"
            label={t('first_face_id') as unknown as string}
            {...register('content.filters.face_id__gte', { validate: validate.uuid() })}
            errors={errors}
            placeholder={t('enter_id') as unknown as string}
          />
        </div>

        <div className={st.Column}>
          <Control.Input
            errors={errors}
            id="content.filters.face_ids"
            label={t('face_ids') as unknown as string}
            placeholder={t('enter_comma_separated') as unknown as string}
            {...register('content.filters.face_ids', { validate: validate.multipleUuid() })}
          />
          <Divider small />

          <Control.Input
            id="content.filters.external_ids"
            label={t('face_external_ids') as unknown as string}
            {...register('content.filters.external_ids', { validate: validate.multipleExternalId() })}
            errors={errors}
            placeholder={t('enter_comma_separated') as unknown as string}
          />
          <Divider small />

          <Control.DateInput
            control={control}
            enableTime
            id="content.filters.create_time__lt"
            label={t('create_date_to') as unknown as string}
            name="content.filters.create_time__lt"
            options={END_OF_DAY}
            placeholder={t('choose_dates') as unknown as string}
          />
          <Divider small />

          <Control.Input
            id="content.filters.face_id__lt"
            label={t('last_face_id') as unknown as string}
            {...register('content.filters.face_id__lt', { validate: validate.uuid() })}
            errors={errors}
            placeholder={t('enter_id') as unknown as string}
          />
        </div>
      </div>
      <Divider small />
    </Step>
  );
}

StepFacesFilters.fieldNames = [
  'content.filters',
  'meta',
];
